
import {Component, Vue} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'scroll-top',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {

  private scrollUp() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
}
